import axiosConfig from 'utils/api';

export const chat = {
  getUserDialog: {
    action: (flowId, userId) =>
      axiosConfig.get(`/api/flow_analytics/v1/get_user_dialog?flow_id=${flowId}&user_id=${userId}`),
    cancel: () => null,
  },
};
